import { TOURNAMENT } from "@/data/tournament";
import totemSportsImg from "@/assets/totem-sports.png";

const About = () => {
  return (
    <section
      id="torneo"
      data-testid="about-section"
      className="relative bg-[#050505] py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={totemSportsImg}
                alt="Totem Sports Center - Tordera"
                className="w-full h-full object-cover contrast-105 saturate-[0.9]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/30 to-transparent" />
              <div className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase text-[#EAB308]">
                / 01
              </div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="text-xs tracking-[0.3em] uppercase text-white/60 mb-2">
                  Sede Oficial
                </div>
                <div className="font-display text-3xl text-white">
                  {TOURNAMENT.venue}
                </div>
                <div className="text-sm text-white/50 mt-1">
                  Tordera · España
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-px bg-[#EAB308]" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#EAB308]">
                ¿Qué es Proxima League?
              </span>
            </div>

            <h2
              className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.95] tracking-tight"
              data-testid="about-title"
            >
              No es un torneo
              <br />
              <span className="text-white/40">cualquiera.</span>
            </h2>

            <p className="mt-8 text-white/70 font-body text-base sm:text-lg leading-relaxed max-w-2xl">
              Proxima League es una competición de fútbol 7 diseñada para
              ofrecer una experiencia <span className="text-white">profesional, estructurada y aspiracional</span> al
              fútbol amateur. Árbitros en todos los partidos, seguro de accidentes incluido,
              cobertura audiovisual y un formato de fase de liga seguida de
              eliminatoria directa que lleva a los <span className="text-[#EAB308]">16 mejores equipos</span> a
              competir por el título en una sola jornada, en dos campos de
              fútbol 11 divididos en mitades: <span className="text-white">4 partidos simultáneos</span>.
            </p>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/10">
              {[
                { k: "16", v: "Equipos" },
                { k: "1", v: "Jornada" },
                { k: "1000€", v: "Premio" },
                { k: "4", v: "Partidos a la vez" },
              ].map((s, i) => (
                <div
                  key={i}
                  className="bg-[#050505] p-5 group hover:bg-[#0a0a0a] transition-colors"
                >
                  <div className="font-display text-3xl sm:text-4xl text-white group-hover:text-[#EAB308] transition-colors">
                    {s.k}
                  </div>
                  <div className="text-[10px] tracking-[0.25em] uppercase text-white/50 mt-1">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
